import { create } from 'zustand';

export interface ModerationNotice {
  action: 'warn' | 'suspend' | 'ban';
  reason: string;
  until: string | null;
}

/** Account closed at sign-in/onboarding: underage birthdate or a banned Google identity (SPEC_V2 §1, §8). */
export type ClosedReason = 'underage' | 'account_banned';

interface ModerationState {
  closed: ClosedReason | null;
  setClosed: (r: ClosedReason | null) => void;
  /** Blocking notice (suspend/ban). The app shows a full-screen block and signs out. */
  blocked: ModerationNotice | null;
  /** Non-blocking warning shown in a modal. */
  warning: ModerationNotice | null;
  setBlocked: (n: ModerationNotice | null) => void;
  setWarning: (n: ModerationNotice | null) => void;
}

export const useModeration = create<ModerationState>((set) => ({
  closed: null,
  setClosed: (closed) => set({ closed }),
  blocked: null,
  warning: null,
  setBlocked: (blocked) => set({ blocked }),
  setWarning: (warning) => set({ warning }),
}));
